import { JOB_SPEC_FRAGMENT } from 'apps/rfq/gql';
import { Mutation, Query } from 'core';
import gql from 'graphql-tag';

const CREATE_PRODUCT_QUOTE = gql`
  mutation CreateProductQuote($input: CreateProductQuoteInput!) {
    createProductQuote(input: $input) {
      id
      currency
      from {
        id
      }
    }
  }
`;

export class CreateProductQuote extends Mutation {
  static conf = {
    GQL: CREATE_PRODUCT_QUOTE,
    inputName: ['input'],
    resultPath: 'createProductQuote',
  };
}

const DELETE_PRODUCT_QUOTE = gql`
  mutation DeleteProductQuote($input: DeleteProductQuoteInput!) {
    deleteProductQuote(input: $input) {
      id
      currency
      from {
        id
      }
    }
  }
`;

export class DeleteProductQuoteMutation extends Mutation {
  static conf = {
    GQL: DELETE_PRODUCT_QUOTE,
    inputName: ['input'],
    resultPath: 'deleteProductQuote',
  };
}

const PRODUCT_QUOTES_BY_ID = gql`
  ${JOB_SPEC_FRAGMENT}
  query ProductQuotesById($ids: [ID!]!) {
    productQuoteList(ids: $ids) {
      id
      cost
      currency
      isEstimated
      isInstantQuote
      isVoid
      validUntil
      for {
        ...jobSpecFields
        build {
          file {
            id
            filename
            permalink
          }
        }
      }
      from {
        id
        customerSpace {
          id
        }
        address {
          id
          name
          company
          address1
          address2
          zip
          city
          province
          country
          phone
          default
        }
        jobSpec {
          ...jobSpecFields
          build {
            file {
              id
              filename
              permalink
            }
          }
        }
      }
      supplier {
        id
        companyName
      }
      createdBy {
        id
      }
      createdAt
    }
  }
`;

export class ProductQuotesById extends Query {
  static conf = {
    GQL: PRODUCT_QUOTES_BY_ID,
    varName: 'ids',
    resultPath: 'productQuoteList',
  };
}
